/**
 * 草图控制点默认屏幕缩放值。
 *
 * 该值是控制点本体与命令态点标记的共同视觉基准，
 * 禁止在各业务预览中重复声明数值。
 */
export const SKETCH_CONTROL_POINT_DEFAULT_SCALE = 0.008;
